export default {
  designs: [],
  selectedSprint: "",
  selectedSubSprint: "",
  platform: "Web",
  version: null,
  selected: {},
  selectedStory: {},
  selectedComponent: {},
  selectedMobileTag: "",
  setselectedroles: {},
  selectedSprintStories: [],
  allComponents: [],
  allImages: [],
  setStoriesType: "",
};
